import { ButtonGroup } from "@chakra-ui/react";
import { ButtonLink } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { usePathname } from "next/navigation";

export const InvoicingPlanLinks = () => {
  const pathname = usePathname();
  const isAutomated = pathname.startsWith("/invoices/invoicing-plan/automated");

  return (
    <ButtonGroup isAttached>
      <ButtonLink
        href="/invoices/invoicing-plan"
        variant={!isAutomated ? "solid" : "outline"}
      >
        <Trans>All</Trans>
      </ButtonLink>
      <ButtonLink
        href="/invoices/invoicing-plan/automated"
        variant={isAutomated ? "solid" : "outline"}
      >
        <Trans>Automated</Trans>
      </ButtonLink>
    </ButtonGroup>
  );
};
